var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagKenya(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.2705C24.8366 32.2705 32 25.1071 32 16.2705C32 7.43395 24.8366 0.270508 16 0.270508C7.16344 0.270508 0 7.43395 0 16.2705C0 25.1071 7.16344 32.2705 16 32.2705Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 0.270508C9.65689 0.270508 4.17589 3.96207 1.58789 9.31401H30.4126C27.8246 3.96207 22.3436 0.270508 16.0003 0.270508Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 32.2706C9.65689 32.2706 4.17589 28.579 1.58789 23.2271H30.4126C27.8246 28.579 22.3436 32.2706 16.0003 32.2706Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2444 11.4009H0.755562C0.265437 12.9364 0 14.5724 0 16.2704C0 17.9685 0.265437 19.6044 0.755562 21.14H31.2444C31.7346 19.6044 32 17.9685 32 16.2704C32 14.5724 31.7346 12.9364 31.2444 11.4009Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9822 7.66411L19.0874 6.78955L16 13.7802L12.9126 6.78955L11.0178 7.66411L14.8508 16.2703L11.0178 24.8765L12.9126 25.751L16 18.7604L19.0874 25.751L20.9822 24.8765L17.1492 16.2703L20.9822 7.66411Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2869 8.48812C16.5534 7.68706 16 7.22656 16 7.22656C16 7.22656 15.4466 7.687 14.7131 8.48812V24.0519C15.4466 24.8531 16 25.3136 16 25.3136C16 25.3136 16.5534 24.8531 17.2869 24.0519V8.48812Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5215 11.473V21.0675C13.2966 22.441 14.2453 23.5667 14.9563 24.3131V8.22754C14.2453 8.97385 13.2965 10.0997 12.5215 11.473Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.478 11.473C18.7028 10.0996 17.7542 8.97385 17.0432 8.22754V24.3131C17.7541 23.5667 18.7028 22.441 19.478 21.0675V11.473Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4785 11.4731V21.0676C20.2632 19.6771 20.8698 18.0328 20.8698 16.2705C20.8698 14.5081 20.2632 12.8638 19.4785 11.4731Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5222 11.4731V21.0676C11.7375 19.6771 11.1309 18.0328 11.1309 16.2705C11.1309 14.5081 11.7375 12.8638 12.5222 11.4731Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.270508)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagKenya);
export default __webpack_public_path__ + "static/media/flag_kenya.d9555299cfa05c810ff99ac9aa9859a5.svg";
export { ForwardRef as ReactComponent };